import { useLayoutEffect } from 'react';

/**
 * Calls `callback` with the element's content width whenever it changes.
 */
const useResizeObserver = <T extends HTMLElement>(
  element: T | null,
  callback: ({ width }: { width: number }) => void,
): void => {
  useLayoutEffect(() => {
    if (!element) {
      return undefined;
    }

    const observer = new ResizeObserver((entries) => {
      callback({ width: entries[0].contentRect.width });
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [element, callback]);
};

export default useResizeObserver;
